import React from 'react';
import PropTypes from 'prop-types';
import {Tooltip, List, Progress, message} from 'antd';

import PB, {SimplePB} from '@/libs/simplePB';

import {getNodeDisplayTitle, getNodeIcon} from "@/constants/vis.defaultDefine.1";

import Icon from '@/components/common/common.icon';
import {showErrorMessage} from "@/components/common/common.message";

import ViewStatisticsWordLogic from "@/components/common/view/statistics/word/common.view.statistics.word.logic";

import style from '@/style/common/view/statistics/common.view.statistics.word.less';

const STATISTIC_CONDITIONS = [{
  type: 'vocabulary',
  limit: 10,
}, {
  type: 'phrase',
  limit: 10,
}];

const RANK_COLOR = {
  'pos_1': '#F28B54',
  'pos_2': '#F7B500',
  'pos_3': '#F6D95E',
  '_default': '#c8c8c8',
};

class ViewStatisticsWordPanel extends React.Component {
  state = {
    conditionIndex: 0,
    rankLoadingStatus: 'idle',
    selectedRankItemIndex: -1,
    listLoadingStatus: 'idle',
  };

  rankContentData = [];

  listContentData = [];

  lastHoverKey = {
    list: undefined,
  };

  availableNodeAmount = 0;

  onClose = () => {
    let me = this;

    me.rankContentData = [];
    me.listContentData = [];
    me.lastHoverKey.list = undefined;
    me.setState({
      conditionIndex: 0,
      rankLoadingStatus: 'idle',
      selectedRankItemIndex: -1,
      listLoadingStatus: 'idle',
    });

    me.props.onClose();
  };

  onBackToRank = () => {
    let me = this;

    me.listContentData = [];
    me.setState({
      selectedRankItemIndex: -1,
      listLoadingStatus: 'idle',
    });
  };

  onRankItemClick = idx => {
    let me = this, text = me.rankContentData[idx].label;

    me.listContentData = me.props.nodes.filter(node => !!node.status && (node.fname || '').indexOf(text) >= 0);
    me.setState({
      selectedRankItemIndex: idx,
      listLoadingStatus: 'success',
    });
  };

  onComponentHover = (type, key) => {
    let me = this;

    if (!me.lastHoverKey[type]) {
      me.lastHoverKey[type] = key;
      me.forceUpdate();
    } else {
      me.lastHoverKey[type] = key;
    }
  };

  delayComponentLostHover = (type, key) => {
    let me = this;

    setTimeout(() => {
      if (me.lastHoverKey[type] === key) {
        me.lastHoverKey[type] = undefined;
        me.forceUpdate();
      }
    }, 10);
  };

  componentDidMount() {
    let me = this;

    me.props.bus.with(me).subscribe('node.statistics', 'word.loaded', ({result}) => {
      me.rankContentData = result;
      me.setState({
        rankLoadingStatus: 'success',
        selectedRankItemIndex: -1,
        listLoadingStatus: 'idle',
      }, () => {
        let unSavedNodes = me.props.nodes.filter(node => !node.status);
        me.availableNodeAmount = me.props.nodes.length - unSavedNodes.length;
        if (unSavedNodes.length > 0) {
          message.info(`请注意，有${unSavedNodes.length}个节点尚未确认保存，因此未列入统计范围`);
        }
      });
    }).subscribe('node.statistics', 'word.failed_to_load', ({code, msg}) => {
      showErrorMessage({code, msg});
      me.setState({
        rankLoadingStatus: 'failed',
        selectedRankItemIndex: -1,
        listLoadingStatus: 'idle',
      });
    });

    // 临时加载数据
    setTimeout(() => {
      me.setState({rankLoadingStatus: 'processing'}, () => {
        me.props.bus.emit('node.statistics', 'word.do_tmp_load',
          {viewId: me.props.viewDataProvider ? me.props.viewDataProvider.viewId : undefined});
      });
    }, 0);
  }

  componentWillUnmount() {
    this.props.bus.remove(this);
  }

  render() {
    let me = this, rankContent, listContent = undefined, listBottom = undefined;

    switch (me.state.rankLoadingStatus) {
      case 'idle':
      case 'processing':
        rankContent = (
          <div key={'rank-loading'} className={style['rank-loading']}>
            <div>
              <Icon name={'loading'} theme={'outlined'}/><br/>
              数据加载中，请稍候...
            </div>
          </div>
        );
        break;
      case 'success':
        if (me.rankContentData.length > 0) {
          rankContent = (
            <List
              key={'rank-content'}
              className={style['rank-content']}
              dataSource={me.rankContentData}
              renderItem={(item, idx) => (
                <List.Item onClick={e => {e.stopPropagation();me.onRankItemClick(idx);}}>
                  <div>
                    <div>
                      <span className={style['rank-item-pos']}>TOP.{item.pos}</span>
                      <span className={style['rank-item-word']}>{item.label}</span>
                    </div>
                    <Progress
                      size="small"
                      strokeColor={RANK_COLOR[`pos_${item.pos}`] || RANK_COLOR['_default']}
                      strokeWidth={6}
                      percent={item.percent}
                      showInfo={false}
                    />
                  </div>
                </List.Item>
              )}
            />
          );
          break;
        }
      // noinspection FallThroughInSwitchStatementJS
      case 'failed':
      default:
        rankContent = (
          <div key={'rank-failed-to-load'} className={style['rank-failed-to-load']}>
            <div>
              <Icon name={'info-circle'} theme={'outlined'}/><br/>
              排名尚未计算完成
            </div>
          </div>
        );
    }
    if (me.state.selectedRankItemIndex >= 0) {
      switch (me.state.listLoadingStatus) {
        case 'idle':
        case 'processing':
          listContent = (
            <div key={'list-loading'} className={style['rank-loading']}>
              <div>
                <Icon name={'loading'} theme={'outlined'}/><br/>
                数据加载中，请稍候...
              </div>
            </div>
          );
          break;
        case 'success':
          if (me.listContentData.length > 0) {
            listContent = (
              <ul
                key={'list-content'}
                className={`${style['list-content']} scrollbar ${me.lastHoverKey['list'] ? 'hover' : ''}`}
              >
                {me.listContentData.map((node) => (
                  node.description ? (
                    <Tooltip
                      key={`n-${node.id}`}
                      placement={'right'}
                      title={
                        node.description.split('\n').map((line, idx) => (
                          <span key={`ln-${idx}`}>{line}<br /></span>
                        ))
                      }
                      mouseLeaveDelay={0.05}
                      onVisibleChange={visible =>
                        visible ? me.onComponentHover('list', `n-${node.id}`) :
                          me.delayComponentLostHover('list', `n-${node.id}`)}
                    >
                      <li onClick={() => me.props.bus.emit('network', 'focus', node)}>
                        <Icon {...getNodeIcon(node)} style={{marginRight: '0.5em'}}/>
                        {getNodeDisplayTitle(node)}
                      </li>
                    </Tooltip>
                  ) : (
                    <li
                      key={`n-${node.id}`}
                      onClick={() => me.props.bus.emit('network', 'focus', node)}
                    >
                      <Icon {...getNodeIcon(node)} style={{marginRight: '0.5em'}}/>
                      {getNodeDisplayTitle(node)}
                    </li>
                  )
                ))}
              </ul>
            );
            listBottom = (
              <div key={'statistics'} className={style['statistics-frame']}>
                <table className={style['statistics-content']}>
                  <colgroup>
                    <col style={{width: '3.8em'}} />
                    <col />
                    <col style={{width: '1em'}} />
                    <col style={{minWidth: '2em'}} />
                    <col style={{width: '1em'}} />
                  </colgroup>
                  <tbody>
                  <tr>
                    <td rowSpan={2} style={{verticalAlign: 'top'}}>
                      词汇 =
                    </td>
                    <td rowSpan={2} style={{verticalAlign: 'top'}}>
                      {me.rankContentData[me.state.selectedRankItemIndex].label}<br />
                    </td>
                    <td />
                    <td style={{textAlign: 'right', paddingRight: '0.5em'}}>{me.listContentData.length}</td>
                    <td>个</td>
                  </tr>
                  <tr>
                    <td style={{textAlign: 'right'}}>共</td>
                    <td style={{textAlign: 'right', paddingRight: '0.5em'}}>{me.availableNodeAmount}</td>
                    <td>个</td>
                  </tr>
                  <tr>
                    <td>
                      排名 =
                    </td>
                    <td>
                      No.{me.state.selectedRankItemIndex + 1}<br />
                    </td>
                    <td style={{textAlign: 'right'}}>占</td>
                    <td style={{textAlign: 'right', paddingRight: '0.5em'}}>{Math.round(me.listContentData.length / me.availableNodeAmount * 10000) / 100}</td>
                    <td>%</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            );
            break;
          }
        // noinspection FallThroughInSwitchStatementJS
        case 'failed':
        default:
          listContent = (
            <div key={'list-failed-to-load'} className={style['list-failed-to-load']}>
              <div>
                <Icon name={'info-circle'} theme={'outlined'}/><br/>
                未发现相关节点
              </div>
            </div>
          );
      }
    }

    return (
      <React.Fragment>
        <div className={style['frame']}>
          <div className={style['header-frame']}>
            词频统计 -
            <Tooltip
              placement={"top"}
              title={"更多统计方式正在开发中，敬请期待..."}
              overlayClassName={'dark-theme'}
            >
              <span style={{cursor: 'pointer'}}> 词汇 Top10</span>
            </Tooltip>
            <Tooltip
              placement={"top"}
              title={"关闭统计面板"}
              overlayClassName={'dark-theme'}
            >
              <a
                onClick={me.onClose}
                style={{float: 'right', marginLeft: '2.5em'}}
              >
                <Icon name={'close'}/>
              </a>
            </Tooltip>
          </div>
          <div key={'rank'} className={style['rank-frame']}>
            {rankContent}
          </div>
        </div>
        {me.state.selectedRankItemIndex >= 0 ? (
          <div className={style['frame']}>
            <div className={style['header-frame']}>
              词频统计 - 相关节点
              <Tooltip
                placement={"top"}
                title={"关闭节点列表"}
                overlayClassName={'dark-theme'}
              >
                <a
                  onClick={me.onBackToRank}
                  style={{float: 'right', marginLeft: '0.5em'}}
                >
                  <Icon name={'close'}/>
                </a>
              </Tooltip>
            </div>
            <div key={'list'} className={style['list-frame']}>
              {listContent}
            </div>
            {listBottom}
          </div>
        ) : undefined}
        {me.props.logic ? me.props.logic : (
          <ViewStatisticsWordLogic bus={me.props.bus} />
        )}
      </React.Fragment>
    )
  }
}

ViewStatisticsWordPanel.defaultProps = {
  bus: PB,
  nodes: [],
};

ViewStatisticsWordPanel.propTypes = {
  onClose: PropTypes.func.isRequired,
  bus: PropTypes.instanceOf(SimplePB),
  nodes: PropTypes.array,
  logic: PropTypes.instanceOf(React.ReactNode),
};

export default ViewStatisticsWordPanel;